module.exports = __webpack_public_path__ + "img/location_dark.4201523b.svg";